import { Tabs, TabsProps } from "antd";
import CompanyAvatar from "../../../assets/images/company-avatar.png";
import { useGetCompanyProfileQuery } from "../../../features/superAdmin/employeeService/employeeManagementService";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { formatDate } from "../../../lib/time";
import TemplateTable from "../TicketManagement/Templates/_components/TemplateTable";
import EmployeesContent from "./_components/EmployeesContent";

const items: TabsProps["items"] = [
  {
    key: "1",
    label: "Templates",
    children: <TemplateTable />,
  },
  {
    key: "2",
    label: "Employees",
    children: <EmployeesContent />,
  },
];

export default function CompanyProfile() {
  const { data } = useGetCompanyProfileQuery({});
  const company = data?.data || {};
  // console.log(company);
  return (
    <SidebarLayout title="Company Profile">
      {/* <Button onClick={() => navigate(-1)} className="flex gap-2 items-center">
        <span>
          <BackButtonIcon />
        </span>
        <span>Back</span>
      </Button> */}
      <div className="grid grid-cols-4 gap-8 border border-slate-200 p-4 items-center bg-white rounded-md">
        <div className="col-span-1">
          <div className="p-2 flex gap-3 items-center">
            <img src={company?.logo || CompanyAvatar} className="w-20" alt="" />
            <div className="text-[#2D3643] text-[28px] font-semibold">
              {company?.company_name}
            </div>
          </div>
        </div>
        <div className="col-span-3">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 p-2">
            <div>
              <div className="text-[#5E718D] text-base">Office Location</div>
              <div className="text-[#2D3643] text-lg font-medium">
                {company?.location}
              </div>
            </div>
            <div>
              <div className="text-[#5E718D] text-base">TIN Number</div>
              {/* {company?.tin_certificate_file_link && ( */}
              {company?.tin_certificate_file_link ? (
                <a
                  href={company.tin_certificate_file_link}
                  target="_blank"
                  className="text-[#2D3643] text-lg font-medium underline underline-offset-2 hover:text-[#2D3643] hover:underline hover:underline-offset-2"
                  rel="noreferrer"
                >
                  TIN.pdf
                </a>
              ) : (
                <span className="text-[#2D3643] text-lg font-medium">N/A</span>
              )}
            </div>
            <div>
              <div className="text-[#5E718D] text-base">BIN Number</div>
              <div className="text-[#2D3643] text-lg font-medium">
                {company?.bin_certificate_file_link ? (
                  <a
                    href={company.bin_certificate_file_link}
                    target="_blank"
                    className="text-[#2D3643] text-lg font-medium underline underline-offset-2 hover:text-[#2D3643] hover:underline hover:underline-offset-2"
                    rel="noreferrer"
                  >
                    BIN.pdf
                  </a>
                ) : (
                  "N/A"
                )}
              </div>
            </div>
            <div>
              <div className="text-[#5E718D] text-base">Trade License</div>
              <div className="text-[#2D3643] text-lg font-medium">
                {company?.trade_certificate_file_link ? (
                  <a
                    href={company.trade_certificate_file_link}
                    target="_blank"
                    className="text-[#2D3643] text-lg font-medium underline underline-offset-2 hover:text-[#2D3643] hover:underline hover:underline-offset-2"
                    rel="noreferrer"
                  >
                    Trade.pdf
                  </a>
                ) : (
                  "N/A"
                )}
              </div>
            </div>
            {/* <div>
              <div className="text-[#5E718D] text-base">Company Admin</div>
              <div className="text-[#2D3643] text-lg font-medium">
                {company?.company_admin ? (
                  <span className="text-[#2D3643] text-lg font-medium">
                    {company?.company_admin}
                  </span>
                ) : (
                  "N/A"
                )}
              </div>
            </div> */}
            <div>
              <div className="text-[#5E718D] text-base">Total Employee</div>
              <div className="text-[#2D3643] text-lg font-medium">
                {company?.totalEmployeeCount}
              </div>
            </div>
            <div>
              <div className="text-[#5E718D] text-base">Total Tickets</div>
              <div className="text-[#2D3643] text-lg font-medium">
                {company?.totalTicketCount}
              </div>
            </div>
            <div>
              <div className="text-[#5E718D] text-base">Created on</div>
              <div className="text-[#2D3643] text-lg font-medium">
                {formatDate(company?.created_at)}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Tabs defaultActiveKey="1" items={items} />
    </SidebarLayout>
  );
}
